import ArrowForwardIcon from '@mui/icons-material/ArrowForward';
import { Box, Button, Stack, Typography } from '@mui/material';
import React from 'react';
import { useNavigate } from 'react-router-dom';
import {
    publicColors,
    publicDisplayFont,
    publicEditorialBannerSx,
    publicEditorialBodySx,
    publicEditorialTitleSx,
} from './publicTheme';

function scrollToPlans() {
    const el = document.getElementById('precos');
    const headerHeight = document.querySelector('header')?.offsetHeight || 72;
    if (el) {
        window.scrollTo({ top: el.offsetTop - headerHeight, behavior: 'smooth' });
    }
}

export default function PublicCalculatorPlansCta() {
    const navigate = useNavigate();

    const handleClick = () => {
        navigate({ pathname: '/', hash: 'precos' });
        window.setTimeout(scrollToPlans, 160);
    };

    return (
        <Box sx={{ ...publicEditorialBannerSx, my: 3 }}>
            <Stack
                direction={{ xs: 'column', sm: 'row' }}
                spacing={{ xs: 1.5, sm: 3 }}
                alignItems={{ xs: 'stretch', sm: 'center' }}
                justifyContent="space-between"
                sx={{ width: '100%' }}
            >
                <Box sx={{ minWidth: 0 }}>
                    <Typography sx={publicEditorialTitleSx}>
                        Quer saber se a sua farm realmente está lucrando?
                    </Typography>
                    <Typography sx={{ ...publicEditorialBodySx, maxWidth: 640 }}>
                        O Acompanha 3D tem ferramentas essenciais para você gerir sua farm de forma eficiente. E o melhor: você pode começar sem pagar nada!
                    </Typography>
                </Box>
                <Button
                    variant="contained"
                    size="large"
                    endIcon={<ArrowForwardIcon />}
                    onClick={handleClick}
                    sx={{
                        flexShrink: 0,
                        alignSelf: { xs: 'stretch', sm: 'center' },
                        bgcolor: publicColors.primary,
                        color: '#fff',
                        fontFamily: publicDisplayFont,
                        fontWeight: 600,
                        fontSize: { xs: '0.95rem', sm: '1rem' },
                        letterSpacing: '-0.03em',
                        textTransform: 'none',
                        px: 2.5,
                        py: 1.2,
                        borderRadius: 1.25,
                        boxShadow: 'none',
                        whiteSpace: { sm: 'nowrap' },
                        '&:hover': { bgcolor: publicColors.primaryDark, boxShadow: 'none' },
                    }}
                >
                    Começar agora
                </Button>
            </Stack>
        </Box>
    );
}
